import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FALIURE,
  DEVICE_REQUEST,
  DEVICE_SUCCESS,
  DEVICE_FALIURE
} from './LoginConstants'


const intialstate = {
  login_loading : false,
  login : [],
  login_error : '',
  login_success : false,
  device_loading : false,
  device : [],
  device_error : '',
  device_success : false
}

const LoginReducers = (state = intialstate,action) =>{
  switch(action.type){
    case LOGIN_REQUEST : return{
      ...state,
      login_loading:true
    }
    case LOGIN_SUCCESS : return{
      ...state,
      login_loading:false,
      login_success:true,
      login:action.payload
    }
    case LOGIN_FALIURE : return{
      ...state,
      login_error:action.payload
    }
    case DEVICE_REQUEST : return{
      ...state,
      device_loading:true
    }
    case DEVICE_SUCCESS : return{
      ...state,
      device_loading:false,
      device_success:true,
      device:action.payload
    }
    case DEVICE_FALIURE : return{
      ...state,
      device_error:action.payload
    }
    default: return state
  }

}

export default LoginReducers
